import { DocumentationTheme } from "@/api";
import type { DropdownItem, IconName } from "@/wc/components";

export const enum ShareAction {
  SAVE_AS_PDF = "save-pdf",
  SAVE_TO_PORTFOLIO = "save-portfolio",
  SAVE_AS_MARKDOWN = "save-markdown",
  SAVE_AS_README = "save-readme",
  COPY_URL = "copy-url",
}

export const enum ShareOption {
  LINKEDIN = "LinkedIn",
  INSTAGRAM = "Instagram",
  TWITTER = "Twitter",
  FACEBOOK = "Facebook",
  TIKTOK = "TikTok",
}

export const THEMES_PRO: Partial<DocumentationTheme>[] = [DocumentationTheme.DARK, DocumentationTheme.FUN];

export function isProTheme(theme: DocumentationTheme): boolean {
  return THEMES_PRO.includes(theme);
}

export function getDisplayText(action: ShareAction): string {
  switch (action) {
    case ShareAction.SAVE_AS_PDF:
      return "Save as PDF";
    case ShareAction.SAVE_TO_PORTFOLIO:
      return "Save to portfolio";
    case ShareAction.SAVE_AS_MARKDOWN:
      return "Save as Markdown";
    case ShareAction.SAVE_AS_README:
      return "Save as README.md";
    case ShareAction.COPY_URL:
      return "Share public URL";
    default:
      return "";
  }
}

export function isProOption(action: ShareAction): boolean {
  return action === ShareAction.SAVE_AS_MARKDOWN || action === ShareAction.SAVE_AS_README;
}

export function getIcon(action: ShareAction): IconName | undefined {
  switch (action) {
    case ShareAction.SAVE_AS_PDF:
      return "file";
    case ShareAction.SAVE_TO_PORTFOLIO:
      return "grid";
    case ShareAction.SAVE_AS_MARKDOWN:
      return "markdown";
    case ShareAction.SAVE_AS_README:
      return "github";
    case ShareAction.COPY_URL:
      return "link";
    default:
      return undefined;
  }
}

export function createSaveProjectOptions(callback: (action: ShareAction) => void): DropdownItem[] {
  return [
    {
      type: "button",
      text: getDisplayText(ShareAction.SAVE_TO_PORTFOLIO),
      callback: () => callback(ShareAction.SAVE_TO_PORTFOLIO),
      icon: getIcon(ShareAction.SAVE_TO_PORTFOLIO),
    },
    {
      type: "button",
      text: getDisplayText(ShareAction.SAVE_AS_PDF),
      callback: () => callback(ShareAction.SAVE_AS_PDF),
      icon: getIcon(ShareAction.SAVE_AS_PDF),
    },
    {
      type: "button",
      text: getDisplayText(ShareAction.SAVE_AS_README),
      callback: () => callback(ShareAction.SAVE_AS_README),
      icon: getIcon(ShareAction.SAVE_AS_README),
      isProOption: true,
    },
    {
      type: "button",
      text: getDisplayText(ShareAction.SAVE_AS_MARKDOWN),
      callback: () => callback(ShareAction.SAVE_AS_MARKDOWN),
      icon: getIcon(ShareAction.SAVE_AS_MARKDOWN),
      isProOption: true,
    },
    {
      type: "button",
      text: getDisplayText(ShareAction.COPY_URL),
      callback: () => callback(ShareAction.COPY_URL),
      icon: getIcon(ShareAction.COPY_URL),
    },
  ];
}
